<template>
    <j-page>
        <div slot="table">
            <el-card shadow="hover">
                <label slot="header">加密类型</label>
                <el-divider content-position="left">项目支持的加密方式SM4、AES（可通过配置config中的encryptMode字段设置）</el-divider>
                <el-steps :active="2" align-center>
                    <el-step title="国密SM4" icon="el-icon-lock" description="config.js配置/encryptMode = 'SM4'"></el-step>
                    <el-step title="对称加密AES" icon="el-icon-key" description="config.js配置/encryptMode = 'AES'"></el-step>
                </el-steps>
            </el-card>
            <el-card shadow="hover">
                <label slot="header">文档说明</label>
                <p>前端文档：<a class="el-button--text" style="word-break: break-all" href="https://cb.btzh.net:4443/best-idea/web/blob/master/%E5%89%8D%E7%AB%AF%E7%B3%BB%E7%BB%9F%E4%BC%A0%E8%BE%93%E5%8A%A0%E5%AF%86/encrypt.md" target="_blank">https://cb.btzh.net:4443/best-idea/web/blob/master/%E5%89%8D%E7%AB%AF%E7%B3%BB%E7%BB%9F%E4%BC%A0%E8%BE%93%E5%8A%A0%E5%AF%86/encrypt.md</a></p>
                <p>后端文档：<a class="el-button--text" style="word-break: break-all" href="https://cb.btzh.net:4443/best-idea/security/tree/master/%E4%BC%A0%E8%BE%93%E5%8A%A0%E5%AF%86%E6%96%B9%E6%A1%88" target="_blank">https://cb.btzh.net:4443/best-idea/security/tree/master/%E4%BC%A0%E8%BE%93%E5%8A%A0%E5%AF%86%E6%96%B9%E6%A1%88</a></p>
            </el-card>
            <el-card shadow="hover">
                <label slot="header">加密策略</label>
                <el-collapse accordion>
                    <el-collapse-item title="整体加密" name="1">
                        <p>{{response1}}</p>
                    </el-collapse-item>
                    <el-collapse-item title="部分加密 (脱敏程度取决于角色设置的脱敏等级)" name="2">
                        <p>{{response2}}</p>
                    </el-collapse-item>
                    <el-collapse-item title="整体+部分加密 (脱敏程度取决于角色设置的脱敏等级)" name="3">
                        <p>{{response3}}</p>
                    </el-collapse-item>
                </el-collapse>
            </el-card>
            <el-card shadow="hover">
                <label slot="header">脱敏等级</label>
                <el-divider content-position="left">角色管理 - 新增/编辑 - 设置针对角色脱敏等级</el-divider>
                <el-table :data="desensitizationTable" border size="small" >
                    <el-table-column property="type" label="类型" />
                    <el-table-column property="type0" label="不脱敏" />
                    <el-table-column property="type1" label="部分脱敏" />
                    <el-table-column property="type2" label="完全脱敏" />
                </el-table>
            </el-card>
            <el-card shadow="hover">
                <label slot="header">j-sensitive脱敏组件</label>
                <el-divider content-position="left">（部分脱敏/完全脱敏）需要使用脱敏组件解析加载： v-model="value" :encrypt="encrypt_value"</el-divider>
                <j-sensitive v-model="desensitization.name" :encrypt="desensitization.encrypt_name" eye />
                <j-sensitive v-model="desensitization.mobile" :encrypt="desensitization.encrypt_mobile" eye />
                <j-sensitive v-model="desensitization.cardCode" :encrypt="desensitization.encrypt_cardCode" eye />
            </el-card>
        </div>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import JSensitive from "../../components/JComponents/JSensitive/JSensitive";
    export default {
        name: "JEncryptDemo",
        mixins: [PageMixins],
        components: {JSensitive},
        data() {
            return {
                response1: '',
                response2: '',
                response3: '',
                desensitization: {},
                desensitizationTable: [
                    { type: '中文姓名', type0: '李思睿', type1: '李**', type2: '***' },
                    { type: '身份证号', type0: '120110199003195762', type1: '*************5762', type2: '*****************' },
                    { type: '手机号码', type0: '13805170034', type1: '138******34', type2: '***********' },
                    { type: '固定电话', type0: '80121234', type1: '****1234', type2: '********' },
                    { type: '地址', type0: '北京市海淀区朝阳路32号', type1: '北京市海淀区****', type2: '***************' },
                    { type: '电子邮箱', type0: 'gzj@163.com', type1: 'g**@163.com', type2: '**********' },
                    { type: '银行卡号', type0: '622260092136854311234', type1: '6222600**********1234', type2: '*********************' },
                    { type: '公司开户银行联号', type0: '1234567890', type1: '12********', type2: '**********' },
                ]
            }
        },
        created() {
            this.getTestType1()
            this.getTestType2()
            this.getTestType3()
        },
        methods: {
            async getTestType1 () {
                const { data } = await this.$http.post(`/api/test/type`)
                this.response1 = data
            },
            async getTestType2 () {
                const { data } = await this.$http.post(`/api/test/type2`)
                this.response2 = data
            },
            async getTestType3 () {
                const { data } = await this.$http.post(`/api/test/type3`)
                this.response3 = data
                this.desensitization = this.response3.data.data[0] || {}
            }
        }
    }
</script>

<style lang="scss">

</style>
